var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.39404 10.6059V1.3938H10.6062V10.6059H1.39404Z",
    stroke: "currentColor",
    strokeWidth: 1.0004
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92746 3.00586C4.63663 3.00435 5.08147 3.77108 4.72821 4.38597C4.56358 4.67258 4.25798 4.849 3.92746 4.84829C3.21833 4.84677 2.77673 4.07815 3.1326 3.46476C3.29706 3.18131 3.59975 3.00658 3.92746 3.00586Z",
    stroke: "currentColor",
    strokeWidth: 1.0004
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39404 8.30298H10.6062",
    stroke: "currentColor",
    strokeWidth: 1.0004
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6062 7.3816L7.84256 4.61792L4.15771 8.30281",
    stroke: "currentColor",
    strokeWidth: 1.0004
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.b8e2f901.svg";
export { ForwardRef as ReactComponent };